<mat-form-field class="search-combo-field">
  <mat-label [ngClass]="{ 'label-closed': !isDropdownOpen, 'label-open': isDropdownOpen }">{{ placeholder }}</mat-label>
  <mat-select panelClass="search-combo-select" #select [formControl]="formCtrl" (selectionChange)="output()" (openedChange)="openChange($event)">
    <mat-select-trigger>
      {{ selectValue }}
    </mat-select-trigger>

    <div class="select-over-lay">
      <input matInput #searchOptInput class="input" (keyup)="filtering($event.target.value)" [autocomplete]="autoComplete" />

      <div class="options-content">
        @if (useVirtualScroll) {
          <cdk-virtual-scroll-viewport itemSize="20" [style.height.px]="viewportHeight">
            <mat-option *cdkVirtualFor="let option of displayOptions" [value]="option.value" (click)="$event.stopPropagation()">
              <span class="option-label-overflow" [matTooltip]="option.label" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
                {{ option.label }}
              </span>
            </mat-option>
          </cdk-virtual-scroll-viewport>
        } @else {
          @for (option of displayOptions; track option.value) {
            <mat-option [value]="option.value" (click)="$event.stopPropagation()">
              <span class="option-label-overflow" [matTooltip]="option.label" matTooltipPosition="above" matTooltipClass="tooltip-overflow">
                {{ option.label }}
              </span>
            </mat-option>
          }
        }
      </div>
    </div>
  </mat-select>
</mat-form-field>
